
export enum ActionStatus {
    NEW = 'NEW',
    SUBMITTED = 'SUBMITTED',
    REJECTED = 'REJECTED',
    NO_EMAIL = 'NO_EMAIL',
    EXECUTED = 'EXECUTED',
    EMAIL_SENT = 'EMAIL_SENT',
    EMAIL_DELIVERED = 'EMAIL_DELIVERED',
    EMAIL_OPENED = 'EMAIL_OPENED',
    DIRECTMAILER_DRY_RUN = 'DRY_RUN',
    DIRECTMAILER_CANCELED = 'CANCELED',
    DIRECTMAILER_PRE_PRODUCTION = 'PRE_PRODUCTION',
    DIRECTMAILER_IN_PRODUCTION = 'IN_PRODUCTION',
    DIRECTMAILER_CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS = 'CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS',
    DIRECTMAILER_IN_MAILSTREAM = 'IN_MAILSTREAM',
    DIRECTMAILER_MARKED = 'MARKED',
    DIRECTMAILER_USPS_RETURNED_TO_SENDER = 'USPS_RETURNED_TO_SENDER',
    DIRECTMAILER_USPS_FORWARDED = 'USPS_FORWARDED',
    SENDGRID_RESUBSCRIBED = 'SENDGRID_RESUBSCRIBED',
    SENDGRID_UNSUBSCRIBED = 'SENDGRID_UNSUBSCRIBED'

}

export enum DirectMailerStatus {
    DRY_RUN = 'DRY_RUN',
    CANCELED = 'CANCELED',
    PRE_PRODUCTION = 'PRE_PRODUCTION',
    IN_PRODUCTION = 'IN_PRODUCTION',
    CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS = 'CANCELED_DUE_TO_NON_DELIVERABLE_ADDRESS',
    IN_MAILSTREAM = 'IN_MAILSTREAM',
    MARKED = 'MARKED',
    USPS_RETURNED_TO_SENDER = 'USPS_RETURNED_TO_SENDER',
    USPS_FORWARDED = 'USPS_FORWARDED',
    REJECTED = 'REJECTED'
}